import React from 'react';

type Props = {
	className?: string;
};
export const SupRequired = ({ className = '' }: Props) => <sup className={className}>*</sup>;
